module.exports = __webpack_public_path__ + "img/sld_mfm_inv_15_t1_b1_dark.2f96d4f1.svg";